import screenSizes from "@swa-ui/browser/assets/styles/sass/defines/_mediaQueries.module.scss";

export default screenSizes;
